export interface OnboardingState {
  onError: string
  createdBillingUser: boolean
  paddleData: PaddleData | {}
}

export const initialState = {
  onError: '',
  createdBillingUser: false,
  paddleData: {},
}

export const onboarding = (
  state: OnboardingState = initialState,
  action: ReduxAction,
): any => {
  switch (action.type) {
    case 'RESET_ONBOARDING_CREATE_USER_FAILED': {
      return {
        ...state,
        ...initialState,
      }
    }
    case 'ONBOARDING_CREATED_NEW_BILLING_USER':
      return {
        ...state,
        createdBillingUser: true,
        paddleData: {
          ...action.payload,
        },
      }
    case 'ONBOARDING_CREATE_USER_FAILED':
      return {
        ...state,
        onError: action.payload,
      }
    default:
      return state
  }
}
